package com.royceecoleman.bill.pages

import androidx.compose.runtime.Composable
import com.royceecoleman.bill.auth.displayName
import com.varabyte.kobweb.core.Page
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun dashboardPage() {
    GuardedAdminPage(
        checkingMessage = "Loading the correct dashboard for your account.",
        redirectingToLoginMessage = "You need to sign in before accessing admin tools.",
        redirectingToMapMessage = "Customer accounts go straight to their BILL workbench.",
    ) { authenticatedSession ->
        CardPage(
            title = "Admin Dashboard",
            supportingText =
                "Signed in as ${authenticatedSession.username} (${authenticatedSession.role.displayName()}). " +
                    "Use these shortcuts to manage Bill.",
        ) {
            Div(
                attrs = {
                    style {
                        property("display", "grid")
                        property("gap", "1rem")
                        property("margin-top", "1.5rem")
                    }
                },
            ) {
                DashboardAction(
                    label = "Home page",
                    description = "Open the billing workbench.",
                    destination = "/",
                )
                DashboardAction(
                    label = "Account management",
                    description = "Create Admin or Customer accounts based on your role.",
                    destination = "/account-management",
                )
                DashboardAction(
                    label = "BILL operations",
                    description = "Models, costs, customer activity, account controls, complimentary access, support, and audit history.",
                    destination = "/analytics",
                )
                DashboardAction(
                    label = "AI chat",
                    description = AI_CHAT_DASHBOARD_DESCRIPTION,
                    destination = "/ai-chat",
                )
                DashboardAction(
                    label = "Settings",
                    description = AI_MODEL_SETTINGS_DASHBOARD_DESCRIPTION,
                    destination = "/settings",
                )
            }
        }
    }
}

@Composable
private fun DashboardAction(
    label: String,
    description: String,
    destination: String,
) {
    Div(
        attrs = {
            style {
                property("padding", "1rem")
                property("border", "1px solid #cbd5e1")
                property("border-radius", "0.85rem")
                property("background", "#f8fafc")
            }
        },
    ) {
        Button(
            attrs = {
                onClick { window.location.href = destination }
                style {
                    property("width", "100%")
                    property("padding", "0.9rem 1rem")
                    property("border", "0")
                    property("border-radius", "0.8rem")
                    property("background", "#2563eb")
                    property("color", "#ffffff")
                    property("font-size", "1rem")
                    property("font-weight", "700")
                    property("cursor", "pointer")
                }
            },
        ) {
            Text(label)
        }
        P(
            attrs = {
                style {
                    property("margin", "0.8rem 0 0")
                    property("color", "#475569")
                    property("line-height", "1.6")
                }
            },
        ) {
            Text(description)
        }
    }
}
